import type { ComponentProps } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { getStatusInitials } from '@/utils/get-status-initials'

const sharedStyles = {
  warning: 'bg-alert-warning',
  success: 'bg-alert-success',
  danger: 'bg-alert-danger',
  monochromatic: 'bg-monochromatic-400',
}

const badgeVariants = tv({
  base: 'size-6 content-center text-white rounded-full text-center text-xs font-bold',
  variants: {
    variant: {
      // Status de contrato de patrocínio
      '1': sharedStyles.warning,
      '2': sharedStyles.warning,
      '3': sharedStyles.warning,
      '4': sharedStyles.success,
      '5': sharedStyles.monochromatic,
      '6': sharedStyles.danger,
    },
  },
  defaultVariants: {
    variant: '1',
  },
})

interface SponsorshipStatusBadgeProps
  extends ComponentProps<'div'>,
    VariantProps<typeof badgeVariants> {
  description: string
}

export function SponsorshipStatusBadge({
  variant,
  className,
  description,
  ...props
}: SponsorshipStatusBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={badgeVariants({
              variant,
              className,
            })}
            {...props}
          >
            <span>{getStatusInitials(description)}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
